import { Box, type SxProps, type Theme, ThemeProvider, Typography, useTheme } from "@mui/material";
import { useMemo } from "react";

import { createFernieFontTheme, FERNIE_FONT_NAME, fernieColors } from "~/themes/fernieBrand";

interface FernieNameProps {
	trademark?: boolean;
	color?: string;
	fontSize?: number | string;
	sx?: SxProps<Theme>;
}

const FernieName = ({ trademark = false, color = fernieColors.tile, fontSize = "inherit", sx }: FernieNameProps) => {
	const outerTheme = useTheme();
	const nameTheme = useMemo(() => createFernieFontTheme(outerTheme, FERNIE_FONT_NAME), [outerTheme]);

	return (
		<ThemeProvider theme={nameTheme}>
			<Typography
				component="span"
				sx={{ color, fontSize, fontWeight: 700, letterSpacing: "-0.01em", lineHeight: 1, ...sx }}
			>
				fernie
				{trademark && (
					<Box
						component="sup"
						sx={{ fontSize: "0.4em", fontWeight: 600, lineHeight: 1, ml: "0.08em", verticalAlign: "top" }}
					>
						™
					</Box>
				)}
			</Typography>
		</ThemeProvider>
	);
};

export default FernieName;
